import {Component, ElementRef, Inject, Injectable, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ReCaptchaComponent} from 'angular2-recaptcha';
import { ReCaptcha2Component } from 'ngx-captcha';
import { BnLoginStorageService } from "@bndes/bndes-ux4/bn-login";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { MessageChannelService, BnStringUtils } from "@bndes/bndes-ux4/bndes-angular-utils"; 

import {LoginService} from './login.service';

export const CNPJ_BNDES = '33657248000189';

export class User {
    public log_cnpj: string;
    public log_userName: string;
    public log_senha: string;
}

@Injectable()  
export abstract class TelaLoginBaseComponent implements OnInit {

    @ViewChild('log_senha', { static: true }) passwordElement: ElementRef;

    @ViewChild('captchaElem') captcha: ReCaptcha2Component;

    carregando = false;

    returnUrl: string;

    public solicitarCnpj = false;
    public layoutCompacto = true;
    public autoPreencherLogin = false;
    
    model = new User();

    pedirCaptcha = false;
    loginCaptchaChaveCliente: string;

    loginCaptchaResposta: string = undefined;
    
    constructor(protected route: ActivatedRoute,
        protected router: Router,
        protected usuarioService: BnUsuarioService,
        protected bndesUxConfig: any,
        protected loginStorageService: BnLoginStorageService,
        protected loginService: LoginService,
        protected messageService: MessageChannelService) {

        this.loginCaptchaChaveCliente = this.bndesUxConfig.chaveCaptchaLogin;
    }

    ngOnInit() {

        //Esconde o botão de novo usuário caso seja login Agente Financeiro do Canal MPME e Carrega o CNPJ
        if (this.route.snapshot.queryParams['tipoPessoa'] == 'AF') {
            this.model.log_cnpj = this.route.snapshot.queryParams['cnpj'];
            document.getElementById("txt.userName-ux4")?.focus();
        }

        if (this.route.snapshot.queryParams['returnUrl']) {
            this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
            //atualiza a sessão normalmente se a origem da chamada não for as novas telas de início do Canal MPME
            if (!this.route.snapshot.queryParams['returnUrl'].match(/login-inicio/) && !this.route.snapshot.queryParams['returnUrl'].match(/login-acessogov/) && !this.route.snapshot.queryParams['returnUrl'].match(/login-af/)) {
                if (sessionStorage) {
                    sessionStorage.setItem('returnUrl', this.returnUrl);
                }
            }
        } else if (sessionStorage && sessionStorage.getItem('returnUrl')) {
            this.returnUrl = sessionStorage.getItem('returnUrl');
        } else {
            this.returnUrl = '/dashboard';
        }

        console.log('ReturnUrl: ', this.returnUrl);
        console.log('Query Param cnpj : ' + this.route.snapshot.queryParams['cnpj']);

        const hasRouteData = this.route && this.route.snapshot && this.route.snapshot.data && this.route.snapshot.data[0];

        if (hasRouteData) {
            const routeData = this.route.snapshot.data[0];
            this.solicitarCnpj = routeData['solicitarCnpj'] != null ? routeData['solicitarCnpj'] : this.solicitarCnpj;
            this.layoutCompacto = routeData['layoutCompacto'] != null ? routeData['layoutCompacto'] : this.layoutCompacto;
            this.autoPreencherLogin = routeData['autoPreencherLogin'] != null ? routeData['autoPreencherLogin'] : this.autoPreencherLogin;
        }

        console.log("URL: " + this.returnUrl);
        this.recuperarValoresDoLocalStorage();

    }
    
    // handleCorrectCaptcha($event) {
    //     this.loginCaptchaResposta = $event;
    // }

    public executaLogin(event: Event, tratarBndes: boolean = false, cont: number = 0) {
    
        let cnpj = this.model.log_cnpj;

        if( tratarBndes
            && this.model.log_cnpj == CNPJ_BNDES
            && this.model.log_userName !== undefined
            && this.model.log_senha !== undefined) {
                cnpj = null;
        }

       
        let categoria = 'pessoa jurídica';
        if (this.ehBndes(this.model.log_cnpj)) {
            categoria = 'interno';
        }
        if (this.model.log_cnpj === this.model.log_userName) {
            categoria = 'pessoa física';
        }

        this.armazenarValoresNoLocalStorage();
        this.carregando = true;

        const parametrosExtrasParaOLogin: Map<string, string> = new Map();
        parametrosExtrasParaOLogin.set('urlDeOrigem', this.returnUrl);

        // Efetua login
        //
        this.efetuaLogin(cnpj, categoria, tratarBndes, parametrosExtrasParaOLogin);        
    }


    protected efetuaLogin(cnpj: string, categoria: string, tratarBndes: boolean, parametrosExtrasParaOLogin: Map<string, string>): void {
        // Faz chamada para efetuar o login
        //
        this.usuarioService.login(cnpj, this.model.log_userName, this.model.log_senha, this.loginCaptchaResposta, parametrosExtrasParaOLogin)
            .subscribe(
                response => {
                    this.loginService.loginCompletouComSucesso(this.returnUrl, categoria);
                    
                    this.carregando = false;
                    this.pedirCaptcha = false;
                },
                error => {
                    console.log(error);
                    this.carregando = false;

                    if (error.status === 401) {
                        /* 
                        if (!tratarBndes) {
                            this.executaLogin(event, true);
                        }
                        */

                        if (error.error && error.error.codigo !== undefined && error.error.codigo === 'CAPTCHA_NEEDED') {
                            this.pedirCaptcha = true;

                            if (this.captcha) {
                                this.captcha.reloadCaptcha();
                                this.loginCaptchaResposta = undefined;
                            }
                        } else {
                            this.pedirCaptcha = false;
                        }
                    }
                    
                    this.loginService.loginCompletouComFalha(categoria, error, this.pedirCaptcha);
                    
                }
            );
    }

    tratarCNPJ() {

        if (this.model.log_cnpj && typeof this.model.log_cnpj !== 'undefined') {
            if (this.model.log_cnpj.toUpperCase() === 'BNDES') {
                this.model.log_cnpj = CNPJ_BNDES;
            } else if (this.model.log_cnpj.length > 0 && this.model.log_cnpj.length < 11) {
                this.model.log_cnpj = this.model.log_cnpj.replace(/[^0-9A-Za-z]+/g, '').padStart(14, '0');
            }
            this.model.log_cnpj = this.model.log_cnpj.toUpperCase();
        }
    }

    
    protected armazenarValoresNoLocalStorage() {
        let cnpj, cpf, login: string;
       
        if (BnStringUtils.isNotBlank(this.model.log_cnpj)) {
            cnpj = this.model.log_cnpj;
        }
        const userNameInputValue = this.model.log_userName;
        if (this.ehCpf(userNameInputValue)) {
            cpf = userNameInputValue;
        } else {
            login = userNameInputValue;
        }
        this.loginStorageService.storeFields(cnpj, cpf, login);
    }

    protected recuperarValoresDoLocalStorage() {
        const loginData = this.loginStorageService.recover();
        if (BnStringUtils.isNotBlank(loginData.cnpj)) {
            this.model.log_cnpj = loginData.cnpj;
            this.model.log_userName = loginData.cpf || loginData.login;
            document.getElementById('txt.senha-ux4')?.focus();
        } else if (BnStringUtils.isNotBlank(loginData.cpf)) {
            this.model.log_cnpj = loginData.cpf;
            this.model.log_userName = loginData.cpf || loginData.login;
            document.getElementById('txt.senha-ux4')?.focus();
        }
    }

    protected ehCpf(texto: string) {
        return BnStringUtils.somenteNumeros(texto).length === 11;
    }


    protected ehBndes(cnpj: string): boolean {
        if (BnStringUtils.isBlank(cnpj)) {
            return true;
        }
        return cnpj.toUpperCase() === 'BNDES'
            || BnStringUtils.somenteNumeros(cnpj) === CNPJ_BNDES;
    }

}
